<script setup>
import { ref } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: 'today',
  },
});

const emit = defineEmits(['update:modelValue', 'change']);

const periods = [
  { key: 'today', label: 'Hoje' },
  { key: 'yesterday', label: 'Ontem' },
  { key: '7d', label: '7 dias' },
  { key: '30d', label: '30 dias' },
];

const selectedFrom = ref('');
const selectedTo = ref('');
const showCustom = ref(false);

const selectPeriod = key => {
  showCustom.value = key === 'custom';
  emit('update:modelValue', key);
  if (key !== 'custom') {
    emit('change', { period: key });
  }
};

const applyCustom = () => {
  if (!selectedFrom.value || !selectedTo.value) return;
  emit('change', {
    period: 'custom',
    from: selectedFrom.value,
    to: selectedTo.value,
  });
};
</script>

<template>
  <div class="flex flex-wrap gap-2 items-center">
    <NextButton
      v-for="p in periods"
      :key="p.key"
      :label="p.label"
      :variant="modelValue === p.key ? 'solid' : 'faded'"
      :color="modelValue === p.key ? 'blue' : 'slate'"
      size="sm"
      @click="selectPeriod(p.key)"
    />
    <NextButton
      label="Personalizado"
      :variant="modelValue === 'custom' ? 'solid' : 'faded'"
      :color="modelValue === 'custom' ? 'blue' : 'slate'"
      size="sm"
      @click="selectPeriod('custom')"
    />

    <div v-if="showCustom" class="flex gap-2 items-center ml-2">
      <input
        v-model="selectedFrom"
        type="date"
        class="px-2 py-1 text-sm rounded border border-n-weak bg-n-alpha-1 text-n-slate-12"
      />
      <span class="text-n-slate-11 text-xs">até</span>
      <input
        v-model="selectedTo"
        type="date"
        class="px-2 py-1 text-sm rounded border border-n-weak bg-n-alpha-1 text-n-slate-12"
      />
      <NextButton
        label="Aplicar"
        size="sm"
        solid
        blue
        @click="applyCustom"
      />
    </div>
  </div>
</template>
